<template>
  <Modal
    ref="tenancyHistoriesModal"
    :modalId="modalId"
    modalType="large-modal"
    className="tenancyHistoriesModal"
  >
    <div
      class="modal-header"
      solt="modal-header"
    >
      {{ $t('tenancy.changeHistory') }}
    </div>
    <div
      slot="content"
      class="tenancy-histories__content"
    >
      <UpdateHistories
        :rawHistories="parsedHistories"
      />
    </div>
  </Modal>
</template>

<script>
import Modal from '@/controls/Modal'
import UpdateHistories from '@/controls/UpdateHistories.vue'
import EventBus from '@/utils/eventBus'
import { computed, onUnmounted, unref } from 'vue-demi'
import { HISTORY_SOURCE_TABLE, TENANCY_HISTORY_TYPE } from './consts'
import { useTenancyHistories } from './hook'
import { onMounted } from '@vue/composition-api'

export default {
  name: 'TenancyHistoriesModal',
  components: {
    Modal,
    UpdateHistories,
  },
  setup () {
    const { data: tenancyHistories, refresh: refreshTenancyHistories } = useTenancyHistories()
    onMounted(() => {
      // In order to replace the refresh function of the UpdateHistories component
      // Because uses useQuery method to share the same key of variable
      EventBus.on('update_histories_table', refreshTenancyHistories)
    })
    onUnmounted(() => {
      EventBus.off('update_histories_table', refreshTenancyHistories)
    })
    return {
      tenancyHistories,
      parsedHistories: computed(() => {
        return unref(tenancyHistories).filter(item => item.detail.type !== TENANCY_HISTORY_TYPE.LIFECYCLE)
      }),
      refreshTenancyHistories,
    }
  },
  data () {
    const modalId = `tenancy-histories-${new Date().getTime()}-${Math.floor(Math.random() * 1000)}`
    return {
      modalId,
      HISTORY_SOURCE_TABLE,
    }
  },
  methods: {
    open () {
      this.$refs.tenancyHistoriesModal.open()
    },
    close () {
      this.$refs.tenancyHistoriesModal.close()
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-header {
  font-weight: bold;
  margin-bottom: 15px
}
._modal-container {
  min-height: 100vh;
}
</style>

<style lang="scss">
.tenancyHistoriesModal {
  overflow-y: unset !important;
  max-height: none !important;
}
</style>
